module.exports = __webpack_public_path__ + "img/list_hk1_2_zh.bad9770d.png";